export default "__VITE_ASSET__88dcaf06__"